import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'
import timer from './vuex/demands/timer'
import filter from './vuex/filter/filter'

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

const store = createStore({
    modules: {
        timer: timer,
        filter: filter,
    },
    state() {
        return {
            filterVisible: false,
            menuVisible: true,
            notificacaoVisible: false,
            autoSearch: false,
            darkMode: false,
            module: 'protocolos',
            userGuide: {
                modules: false
            }
        }
    },
    mutations: {
        setFilterVisible(state) {
            state.filterVisible = !state.filterVisible
        },
        setMenuVisible(state) {
            state.menuVisible = !state.menuVisible
        },
        setNotificacaoVisible(state) {
            state.notificacaoVisible = !state.notificacaoVisible
        },
        toggleAutoSearch(state) {
            state.autoSearch = !state.autoSearch
        },
        toggleDarkMode(state) {
            state.darkMode = !state.darkMode
        },
        setModule(state, value) {
            state.module = value
        },
        setUserGuide(state, value){
            state.userGuide[value.key] = true
        }
    },
    actions: {
        setFilterVisible(context) {
            context.commit('setFilterVisible')
        },
        setMenuVisible(context) {
            context.commit('setMenuVisible')
        },
        setNotificacaoVisible(context) {
            context.commit('setNotificacaoVisible')
        },
        toggleAutoSearch(context) {
            context.commit('toggleAutoSearch')
        },
        toggleDarkMode(context) {
            context.commit('toggleDarkMode')
        },
        setModule(context, value) {
            context.commit('setModule', value)
        },
        setUserGuide(context, value){
            context.commit('setUserGuide', value)
        }
    },
    plugins: [vuexLocal.plugin]
})

export default store
